import React from 'react'
import LoginForm from '../components/LoginForm'

function Login() {
  return (
    <div>
        <LoginForm/>
    </div>
  )
}

export default Login